export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Albecollect Developer Portal';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api';

export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD', 'OPTIONS'];

export const CONTENT_TYPES = [
  'application/json',
  'application/x-www-form-urlencoded',
  'multipart/form-data',
  'text/plain',
  'text/xml',
  'application/xml',
];

export const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: 'LayoutDashboard', path: '/' },
  { id: 'merchant-api', label: 'Merchant API', icon: 'Boxes', path: '/merchant-api', badge: 'NEW' },
  { id: 'collection-api', label: 'Collection API', icon: 'Wallet', path: '/collection-api', badge: 'NEW' },
  { id: 'environments', label: 'Environments', icon: 'Globe', path: '/environments' },
  { id: 'authentication', label: 'Authentication', icon: 'Key', path: '/authentication' },
  { id: 'error-explorer', label: 'Error Explorer', icon: 'AlertTriangle', path: '/error-explorer' },
];

export const BOTTOM_NAV_ITEMS = [
  { id: 'search', label: 'Search', icon: 'Search', path: '/search' },
  { id: 'settings', label: 'Settings', icon: 'Settings', path: '/settings' },
];

export const LANGUAGES = [
  { id: 'curl', label: 'cURL', extension: 'sh' },
  { id: 'javascript', label: 'JavaScript', extension: 'js' },
  { id: 'python', label: 'Python', extension: 'py' },
  { id: 'php', label: 'PHP', extension: 'php' },
  { id: 'java', label: 'Java', extension: 'java' },
  { id: 'go', label: 'Go', extension: 'go' },
  { id: 'ruby', label: 'Ruby', extension: 'rb' },
  { id: 'csharp', label: 'C#', extension: 'cs' },
];

export const QUERY_KEYS = {
  ENDPOINTS: 'endpoints',
  ENDPOINT: 'endpoint',
  ENVIRONMENTS: 'environments',
  API_KEYS: 'api-keys',
  CHANGELOG: 'changelog',
  ERRORS: 'errors',
  HISTORY: 'history',
};
